export const certAbi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_mintPrice",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "CallNoPriceMint",
    type: "error",
  },
  {
    inputs: [],
    name: "CallPriceMint",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "ERC721IncorrectOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ERC721InsufficientApproval",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address",
      },
    ],
    name: "ERC721InvalidApprover",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "ERC721InvalidOperator",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "ERC721InvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "ERC721InvalidReceiver",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "ERC721InvalidSender",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ERC721NonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "EmptyBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "MintHasBeenPaused",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SendRequiredAmount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_fromTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_toTokenId",
        type: "uint256",
      },
    ],
    name: "BatchMetadataUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "MetadataUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "metadataURI",
        type: "string",
      },
    ],
    name: "NoPriceMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "canMint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentTokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "metadataURI",
        type: "string",
      },
    ],
    name: "priceMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newBaseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];
export const certBytecode =
  "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";
 

export const walletAbi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmptyBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];
export const walletBytecode = "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";